<template>
	<form autocomplete="off">
		<div class="container-fluid no-select" ref="payPalFormContainer" v-cloak>

			<div class="row row-your-credit" v-if="creditMode">
				<div class="col-12 mt-3">
					<h4 class="text-center"><span class="text-black mb-3">ContentBASE Account Credit: </span><span class="text-black">{{accountCredit}}</span></h4>
				</div>
			</div>

			<div class="row row-your-credit-package" v-if="packageMode">
				<div class="col-12 mt-3">
					<h4 class="text-center"><span class="text-black mb-3">Your Bundle: </span><span class="text-black">{{pckName}}</span></h4>
				</div>
				<div class="col-12 col-no-dp-no-v" v-show="NoDP_NoV">
					<h4><span class="text-black">${{strNrCredits}}</span></h4>
				</div>
				<div class="col-12 col-yes-dp-no-v" v-show="YesDP_NoV">
					<h3><span class="text-gray strike-gray">${{strNrCredits}}</span><span class="text-black ms-3">${{strDiscPerNrCredits}}</span></h3>
					<p><span class="text-green fw-bold">You save ${{strDiscPerSavedNrCredits}} ({{strDiscPerPct}}%)</span></p>
				</div>
				<div class="col-12 col-no-dp-yes-v" v-show="NoDP_YesV">
					<h3><span class="text-gray strike-gray">${{strNrCredits}}</span><span class="text-black ms-3">${{strVoucherNrCredits}}</span></h3>
					<p><span class="text-green fw-bold">You save ${{strVoucherSavedNrCredits}} ({{strVoucherPct}}%)</span></p>
				</div>
			</div>

			<div class="row" v-show="!paymentSuccess">
				<div class="col-0 col-sm-2 mt-3">
				</div>
				<div class="col-12 col-sm-8 mt-3 overlay-container">
					<!-- do not change id, this is where paypal mounts its buttons -->
					<div id="paypal-button-container"></div>
					<div class="overlay" v-show="processing"></div>
				</div>
				<div class="col-0 col-sm-2 mt-3">
				</div>
				<div class="col-lg-4 order-lg-1 order-3 center-all col-loading-indicator" v-show="processing">
					<img src="/img/loaders/Pulse-1s-200px.png" class="img-paypal-loader">
				</div>
				<div class="col-lg-4 order-lg-1 order-3 center-all col-promo-code" v-show="!processing">
					<voucher @code-applied="updateVoucherCode($event)" @code-removed="updateVoucherCode($event)" v-show="showVoucher"></voucher>
				</div>
				<div class="col-lg-4 order-lg-2 order-2 center-all col-buy-button">
				</div>
				<div class="col-lg-4 order-lg-3 order-1 center-all col-card-icons">
					<img src="/img/credits/4-cards-horizontal.svg" class="img-card-icons">
				</div>

				<div class="col-12" v-show="paymentFailure">
					<p class="text-center m-0"><span class="text-danger">{{paymentFailureFeedback}}</span> Please try again.</p>
					<p class="text-center m-0"><a href="/contact/" target="_blank" rel="nofollow">Contact us</a> if you need help.</p>
				</div>
			</div>

			<div class="row mt-3" ref="rowPaymentSuccess" v-show="paymentSuccess">
				<div class="col-12">
					<h5 class="text-center">Payment successfully processed!</h5>
					<p class="big-bold-black text-center">{{enjoyMessage}}</p>
				</div>
			</div>

		</div>
	</form>
</template>




<script>
	// This components depends on:
	// https://www.paypal.com/sdk/js

	import voucher from '../common/Voucher.vue';

	export default {
		mixins: [mixinAxios],
		components: {
			voucher
		},
		data: () => ({
			stripeObjects : {},
			processing: false,
			paymentFailure: false,
			paymentSuccess: false,
			lastErrorCode: null,
			voucher : {}
		}),
		props: {
			// which mode: credit/package
			mode                : { type: String, default: null },

			// buying account credit mode
			crdNrCredits        : { type: Number, default: 0 },

			// buying package mode
			pckId               : { type: Number, default: 0 },
			pckName             : { type: String, default: null },
			pckNrCredits        : { type: Number, default: 0 },
			pckDiscPerId        : { type: Number, default: null },
			pckDiscPerNrCredits : { type: Number, default: null },

			// other info
			usrNrCredits        : { type: Number, default: 0 }
		},
		mounted() {
			this.initPayPal();
		},
		methods: {
			logWarning(msg, obj = null) {
				var json = null;
				var isError = common.isErrorObject(obj);

				if (isError) {
					msg = `${msg} ${obj.toString()}`;
				} else {
					json = (typeof obj === 'string')
						? obj
						: JSON.stringify(obj);
				}

				var log = {
					class : 'PayPalForm.vue',
					message : msg,
					json : json,
					logType : 4 // warning
				};

				return this.mixinAxios().post('/api/user/InsertLog', log);
			},
			ppCreateOrderForCredit(data, actions) {
				return this.mixinAxios().post('/api/user/CreatePayPalOrderForCredit/', this.crdNrCredits, { headers: { 'Content-Type': 'application/json' } })
					.then((result) => {
						return result.data.order.id;
					})
					.catch(() => {
						//console.log('ppCreateOrderForCredit() - Fail()');
						this.setStateToStopProcessing();
					});
			},
			ppCreateOrderForPackage(data, actions) {
				var packageIDAndVoucherID = {
					packageID : this.pckId,
					voucherID : this.voucher?.id ?? 0,
					voucherCode : this.voucher?.code ?? ''
				};

				return this.mixinAxios().post('/api/user/CreatePayPalOrderForPackage/', packageIDAndVoucherID)
					.then((result) => {
						return result.data.order.id;
					})
					.catch(() => {
						//console.log('ppCreateOrderForPackage() - Fail()');
						this.setStateToStopProcessing();
					});
			},
			ppCreateOrder(data, actions) {
				return (this.creditMode)
					? this.ppCreateOrderForCredit(data, actions)
					: (this.packageMode)
					? this.ppCreateOrderForPackage(data, actions)
					: null;
			},
			_ppOnApprove(apiUrl, data, actions) {
				this.setStateToStartProcessing();

				var payPalOrderLog = {
					accelerated            : data.accelerated,
					billingToken           : data.billingToken,
					facilitatorAccessToken : data.facilitatorAccessToken,
					orderID                : data.orderID,
					payerID                : data.payerID,
					paymentID              : data.paymentID,
					paymentSource1         : data.paymentSource
				};

				return this.mixinAxios().post(apiUrl, payPalOrderLog)
					.then((result) => {
						//console.log('_ppOnApprove() - Done()');
						var retVal;

						var vals                 = result.data.vals;
						var data                 = result.data.data;
						var order                = data.order;
						var ppExcMsg             = data.payPalExceptionMsg;
						var orderLog             = data.payPalOrderLog;
						var awinNotificationInfo = data.awinNotificationInfo;

						var error           = (ppExcMsg != undefined);
						var instDeclined    = (ppExcMsg?.details?.[0]?.issue == 'INSTRUMENT_DECLINED');
						var paymentComplete = (orderLog?.status == 'COMPLETED');

						if (paymentComplete) {
							window.NotifyAwin(awinNotificationInfo);
							this.setStateToStopProcessing(true);
							this.broadcast(vals.nrCredits);
							//this.showSparkles();
							this.$emit('payment-completed');
						} else if (error && !instDeclined) { // error that is not instrument_declined: unrecoverable
							this.lastErrorCode = (ppExcMsg?.details?.[0]?.description);
							this.setStateToStopProcessing();
						} else if (error && instDeclined) { // an error that is instrument_declined: recoverable
							this.lastErrorCode = (ppExcMsg?.details?.[0]?.description);
							this.setStateToStopProcessing();
							retVal = actions.restart();
						}

						return retVal;
					})
					.catch(() => {
						this.logWarning('CreatePayPalOrderLog().catch().', error);
						this.lastErrorCode = null;
						this.setStateToStopProcessing();
					});
			},
			ppOnApprove(data, actions) {
				return (this.creditMode)
					? this._ppOnApprove('/api/user/CreatePayPalOrderLogForCredit/', data, actions)
					: (this.packageMode)
					? this._ppOnApprove('/api/user/CreatePayPalOrderLogForPackage/', data, actions)
					: null;
			},
			ppOnError(error) {
				this.logWarning('PayPal OnError().', error)
				this.setStateToStopProcessing();
			},
			ppRenderError(error) {
				this.logWarning('PayPal button render error.', error)
			},
			initPayPal() {
				const paypalButtonsComponent = paypal.Buttons({
					// optional styling for buttons (https://developer.paypal.com/docs/checkout/standard/customize/buttons-style-guide/)
					style: this.ppStyle,

					// set up the transaction
					createOrder: this.ppCreateOrder,

					// finalize the transaction
					onApprove: this.ppOnApprove,

					// handle unrecoverable errors
					onError: this.ppOnError
				});

				paypalButtonsComponent
					.render("#paypal-button-container")
					.catch(this.ppRenderError);
			},
			resetDefaultView() {
				this.paymentFailure = false;
				this.paymentSuccess = false;
			},
			broadcast(nrCredits) {
				Broadcaster.TransmitCreditsRefresh(nrCredits).then(() => {
				});
			},
			showSparkles() {
				var element = this.$refs['rowPaymentSuccess'];

				party.sparkles(element, {
					count: party.variation.range(50, 50),
				});
			},
			setStateToStartProcessing() {
				this.lastErrorCode  = null;
				this.processing     = true;
				this.paymentFailure = false;
				this.paymentSuccess = false;
				this.$emit('payment-started');
			},
			setStateToStopProcessing(success = false) {
				this.processing     = false;
				this.paymentFailure = !success;
				this.paymentSuccess = success;
				this.$emit('payment-stopped');
			},
			updateVoucherCode(voucher) {
				this.voucher = voucher;
			}
		},
		computed: {
			ppStyle() {
				 return {
					color: 'gold',
					shape: 'rect',
					layout: 'vertical'
				};
			},
			payPalFormContainer() {
				return this.$refs['payPalFormContainer'];
			},
			paymentFailureFeedback() {
				//switch (this.lastErrorCode) {
				//	default : return 'Something went wrong.';
				//}
				return (this.lastErrorCode) ? this.lastErrorCode : 'Something went wrong.';
			},
			voucherApplied() {
				return (this.voucher.id != null);
			},
			voucherNotApplied() {
				return (!this.voucherApplied);
			},
			hasDiscountPeriod() {
				return (this.pckDiscPerId != null);
			},
			notHasDiscountPeriod() {
				return (!this.hasDiscountPeriod);
			},
			showVoucher() {
				var notCreditMode = !this.creditMode;
				return (this.notHasDiscountPeriod && notCreditMode);
			},
			NoDP_NoV() {
				return (this.notHasDiscountPeriod && this.voucherNotApplied);
			},
			YesDP_NoV() {
				return (this.hasDiscountPeriod && this.voucherNotApplied);
			},
			NoDP_YesV() {
				return (this.notHasDiscountPeriod && this.voucherApplied);
			},
			numNrCredits() {
				return this.pckNrCredits;
			},
			numDiscPerPct() {
				return (this.hasDiscountPeriod)
					? (100 - ((this.pckDiscPerNrCredits / this.pckNrCredits) * 100))
					: 0;
			},
			numDiscPerNrCredits() {
				return (this.hasDiscountPeriod)
					? this.pckDiscPerNrCredits
					: 0;
			},
			numDiscPerCreditsSaved() {
				return (this.numNrCredits - this.numDiscPerNrCredits);
			},
			numVoucherPct() {
				return (this.voucherApplied)
					? this.voucher.discountPct
					: 0;
			},
			numVoucherNrCredits() {
				return (this.voucherApplied)
					? (this.pckNrCredits * ((100 - this.voucher.discountPct) / 100))
					: 0;
			},
			numVoucherCreditsSaved() {
				return (this.numNrCredits - this.numVoucherNrCredits);
			},
			strDiscPerPct() {
				return this.numDiscPerPct?.toNrDecimals(0, 2) ?? '';
			},
			strDiscPerNrCredits() {
				return this.numDiscPerNrCredits?.toNrDecimals(2, 2) ?? '';
			},
			strDiscPerSavedNrCredits() {
				return this.numDiscPerCreditsSaved?.toNrDecimals(2, 2) ?? '';
			},
			strVoucherSavedNrCredits() {
				return this.numVoucherCreditsSaved?.toNrDecimals(2, 2) ?? '';
			},
			strVoucherPct() {
				return this.numVoucherPct?.toNrDecimals(0, 2) ?? '';
			},
			strVoucherNrCredits() {
				return this.numVoucherNrCredits?.toNrDecimals(2, 2) ?? '';
			},
			strNrCredits() {
				return this.numNrCredits?.toNrDecimals(2, 2) ?? '';
			},
			modeLower() {
				return this.mode?.toLowerCase();
			},
			creditMode() {
				return (this.modeLower == 'credit');
			},
			packageMode() {
				return (this.modeLower == 'package');
			},
			accountCredit() {
				var strNrCredits = this.crdNrCredits.toNrDecimals(2, 2);
				return `$${strNrCredits}`;
			},
			enjoyMessage() {
				return (this.creditMode)
					? `You have topped up your account credit by ${this.accountCredit}!`
					: (this.packageMode)
					? 'Enjoy your bundle!'
					: null;
			}
		},
		watch: {
		}
	};
</script>




<style scoped>

	/* COMPONENT */

	.img-card-icons {
		width: 200px;
	}

	.div-card-input {
		margin: auto;
		max-width: 400px;
	}

	.img-paypal-loader {
		width: 48px;
	}

	.col-loading-indicator {
		height: 62px;
	}

	.col-promo-code {
		height: 62px;
	}

	.col-buy-button {
		height: 0px;
	}

	.col-card-icons {
		height: 62px;
	}

	.col-no-dp-no-v, .col-yes-dp-no-v, .col-no-dp-yes-v {
		text-align: center;
	}

	@media all and (min-width: 992px) {
		.img-card-icons {
			width: 164px;
		}

		.col-loading-indicator {
			justify-content: center !important;
		}

		.col-promo-code {
			justify-content: start !important;
		}

		.col-card-icons {
			justify-content: end !important;
		}
	}

	/* COMPONENT */




	/* COMMON */

	[v-cloak] {
		display: none;
	}

	.text-black {
		color: black;
	}

	.text-gray {
		color: gray;
	}

	.text-green {
		color: green;
	}

	.strike-black {
		text-decoration: line-through;
		text-decoration-color: black;
	}

	.strike-gray {
		text-decoration: line-through;
		text-decoration-color: gray;
	}

	.big-bold-black {
		font-size: 1.25rem;
		font-weight: bold;
		color: black;
	}

	.big-bold-green {
		font-size: 17px;
		font-weight: bold;
		color: green;
	}

	.strike {
		text-decoration: line-through;
	}

	.underline {
		text-decoration: underline;
	}

	.center-all {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.overlay-container {
		position: relative;
	}

	.overlay {
		background: black;
		opacity: 0.1;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		z-index: 100;
	}

	/* COMMON */

</style>